<template>
  <ShopperAuthLayout>
    <div class="w-full">
      <div class="pt-4">
        <RouterView :channel="'shopper'"> </RouterView>
      </div>
    </div>
  </ShopperAuthLayout>
</template>

<script setup lang="ts">
import ShopperAuthLayout from '@/layouts/ShopperAuthLayout.vue';
import { RouterView } from 'vue-router';
</script>
